import Header48_morph_small from './Header48_morph_small'
export default Header48_morph_small
